import { render, staticRenderFns } from "./RecordStreamax.vue?vue&type=template&id=166ba476&scoped=true&"
import script from "./RecordStreamax.vue?vue&type=script&lang=ts&"
export * from "./RecordStreamax.vue?vue&type=script&lang=ts&"
import style0 from "./RecordStreamax.vue?vue&type=style&index=0&id=166ba476&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166ba476",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('166ba476', component.options)
    } else {
      api.reload('166ba476', component.options)
    }
    module.hot.accept("./RecordStreamax.vue?vue&type=template&id=166ba476&scoped=true&", function () {
      api.rerender('166ba476', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConfiguracionCamaras/Streamax/Record/RecordStreamax.vue"
export default component.exports